import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { PhysicalAddressType } from "../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { TaxReferenceType } from "../../../../../../Wrap/Constants/Enums/Customer/TaxReferenceType";
import { CountryCode } from "../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { AddressInfo } from "../../../../../../Wrap/Models/Models/Customer/AddressInfo";
import { FullClientDetailModel } from "../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { getAgefromDateOfBirth } from "../../../../../Shared/Utils/getAgefromDateOfBirth";
import { NINOHelper } from "../Helpers/NINOHelper";

export class FullClientDetailHelper {
    public static initTaxModel(initArray: Array<any>, data: FullClientDetailModel): Array<any> {
        if (data == null || data.CustomerTaxResidencyDetails == null || data.CustomerTaxResidencyDetails.length == 0) {
            //if CustomerTaxResidencyDetails have nothing add UK to index 0 as UK is a must
            return initArray.concat([
                { value: CountryCode.GBR, path: "CustomerTaxResidencyDetails.0.Country" },
                { value: false, path: "CustomerTaxResidencyDetails.0.IsNationality" },
                { value: false, path: "CustomerTaxResidencyDetails.0.PrimaryCitizenship" },
                { value: true, path: "CustomerTaxResidencyDetails.0.IsTaxResident" },
                { value: TaxReferenceType.GbrNino, path: "CustomerTaxResidencyDetails.0.TaxReferenceType" },
                { value: true, path: "CustomerTaxResidencyDetails.0.PrimaryTaxResidency" },
            ]);
        } else {
            //if CustomerTaxResidencyDetails have anything,
            //check if it has UK and is UK the first one in model,
            //as we set the first counrey to UK and non editable

            // 0824 - User can change primary tax residency to other country later. So need handle this logic
            const gbr = data.CustomerTaxResidencyDetails.find((ele) => ele.Country == CountryCode.GBR) || {
                Country: CountryCode.GBR,
                IsNationality: false,
                PrimaryCitizenship: false,
                IsTaxResident: true,
                TaxReferenceType: TaxReferenceType.GbrNino,
                PrimaryTaxResidency: true,
            };
            const _gbr = JSON.parse(JSON.stringify(gbr));
            _gbr.IsNationality = false;
            _gbr.PrimaryCitizenship = false;
            const primaryTaxResident = data.CustomerTaxResidencyDetails.find(
                (ele) => ele.IsTaxResident && ele.PrimaryTaxResidency
            );
            let taxResidency = [];
            if (primaryTaxResident?.Country == CountryCode.GBR) {
                taxResidency =
                    data.CustomerTaxResidencyDetails.filter(
                        (ele) => ele.IsTaxResident && ele.PrimaryTaxResidency != true
                    ) || [];
            } else {
                taxResidency = data.CustomerTaxResidencyDetails.filter((ele) => ele.IsTaxResident) || [];
            }
            const _taxResidency = JSON.parse(JSON.stringify(taxResidency));
            if (_taxResidency?.length > 0) {
                _taxResidency.forEach((x) => {
                    x.IsNationality = false;
                    x.PrimaryCitizenship = false;
                });
            }

            const nationalityList = data.CustomerTaxResidencyDetails.filter((ele) => ele.IsNationality == true);
            nationalityList.forEach((ele) => (ele.IsTaxResident = false));
            let temp = [];

            temp = temp.concat(_gbr, _taxResidency, nationalityList);
            return initArray.concat([{ value: temp, path: "CustomerTaxResidencyDetails" }]);
        }
    }

    public static updatePostalAddress(initArray: Array<any>, data: FullClientDetailModel): Array<any> {
        if (data.AddressDetails?.length > 0) {
            const hasPostalAddress = data.AddressDetails?.find(
                (ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal
            );
            if (!hasPostalAddress) {
                const temp = this.setPostalAddress(true, data);
                return temp.concat(initArray);
            }
        }
        return initArray;
    }

    public static setPostalAddress(v: boolean, model: FullClientDetailModel): Array<any> {
        const data = model.AddressDetails;
        const index = data?.findIndex((ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential);

        const postalindex = index == 1 ? 0 : 1;
        if (v) {
            return [
                {
                    value: PhysicalAddressType.Postal,
                    path: `AddressDetails.${postalindex}.PhysicalAddressType`,
                },
                {
                    value: data[index]?.Address?.Address1,
                    path: `AddressDetails.${postalindex}.Address.Address1`,
                },
                {
                    value: data[index]?.Address?.Address2,
                    path: `AddressDetails.${postalindex}.Address.Address2`,
                },
                {
                    value: data[index]?.Address?.Address3,
                    path: `AddressDetails.${postalindex}.Address.Address3`,
                },
                {
                    value: data[index]?.Address?.Address4,
                    path: `AddressDetails.${postalindex}.Address.Address4`,
                },
                {
                    value: data[index]?.Address?.Country,
                    path: `AddressDetails.${postalindex}.Address.Country`,
                },
                {
                    value: data[index]?.Address?.PostCode,
                    path: `AddressDetails.${postalindex}.Address.PostCode`,
                },
            ];
        } else {
            data.splice(postalindex, 1);
            return [{ value: data, path: `AddressDetails` }];
        }
    }

    public static isSameAddress(address1: AddressInfo, address2: AddressInfo) {
        if (!address2) {
            return false;
        }
        let isSame = true;
        if (
            address2.Address1 != address1.Address1 ||
            address2.Address2 != address1.Address2 ||
            address2.Address3 != address1.Address3 ||
            address2.PostCode != address1.PostCode ||
            address2.Country != address1.Country
        ) {
            isSame = false;
        }

        return isSame;
    }

    public static fullClientDetailValidation(
        fullClientDetail: FullClientDetailModel
    ): { isValid: boolean; errorMsg: string[] } {
        const isClientYoungerThan16Years = fullClientDetail?.PersonalDetails?.DateOfBirth &&
            getAgefromDateOfBirth(JsonDateParser.toDateNoOffset(fullClientDetail?.PersonalDetails?.DateOfBirth)) < 16;
        const hasResidentialAddress = fullClientDetail?.AddressDetails?.some(
            (ele) => ele.PhysicalAddressType == PhysicalAddressType.Residential
        );
        const residentTax = fullClientDetail?.CustomerTaxResidencyDetails?.find((x) => x.IsTaxResident);
        const isUKTaxReference = residentTax && residentTax.TaxReferenceType == TaxReferenceType.GbrNino;
        let msg: string[] = [];
        if (!isClientYoungerThan16Years && (isUKTaxReference || residentTax == null)) {
            let completeNINO = residentTax && residentTax.TaxReference != null;
            let isCorrectFormat = NINOHelper.IsNINOFormatCorrect(residentTax?.TaxReference);
            if (!completeNINO) {
                msg = msg.concat(["You must enter a complete national insurance number"]);
            }
            if (!isCorrectFormat) {
                msg = msg.concat(["National insurance number is in wrong format!"]);
            }
        }
        if (!hasResidentialAddress) {
            msg = msg.concat(["You must enter residential address"]);
        }
        const hasPostalAddress = fullClientDetail?.AddressDetails.some(
            (ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal
        );

        if (!hasPostalAddress && fullClientDetail?.AddressDetails.length != 1)
            {msg = msg.concat(["You must enter postal address"]);}

        return { isValid: msg.length <= 0, errorMsg: msg };
    }

    public static beforeSave(fullClientDetail: FullClientDetailModel): FullClientDetailModel {
        if (!fullClientDetail) {return null;}
        if (
            FullClientDetailHelper.isSameAddress(
                fullClientDetail?.AddressDetails[0]?.Address,
                fullClientDetail?.AddressDetails[1]?.Address
            )
        ) {
            const addresses = fullClientDetail?.AddressDetails;
            addresses.splice(
                addresses.findIndex((x) => x.PhysicalAddressType == PhysicalAddressType.Postal),
                1
            );
            fullClientDetail.AddressDetails = addresses;
        }

        const _customerTaxResidencyDetails = [];
        fullClientDetail?.CustomerTaxResidencyDetails.forEach((v) => {
            const index = _customerTaxResidencyDetails.findIndex((ele) => ele?.Country == v?.Country);
            if (index == -1) {
                // no hit
                _customerTaxResidencyDetails.push(v);
            } else {
                _customerTaxResidencyDetails[index] = {
                    ..._customerTaxResidencyDetails[index],
                    IsNationality: v?.IsNationality,
                    PrimaryCitizenship: v?.PrimaryCitizenship,
                    NationalIdentifier: v?.NationalIdentifier,
                    PassportNumber: v?.PassportNumber,
                };
            }
        });

        fullClientDetail.CustomerTaxResidencyDetails = _customerTaxResidencyDetails;
        return fullClientDetail;
    }
}
